import Icon from "@ant-design/icons";

const icon = () => (
  <svg
    version="1.1"
    fill="currentColor"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    width="1em"
    viewBox="0 0 120 53.471"
    enableBackground="new 0 0 120 53.471"
    space="preserve"
  >
    <g>
      <path
        d="M114.608,22.471l2.506-7.776c0,0-12.094,5.337-12.094,5.301c-0.155,0.487-0.227,0.856-0.769,2.377
		l-5.791-0.003l2.523-7.726c0,0-12.094,5.426-12.094,5.393c-0.154,0.485-0.246,0.435-0.785,2.435h-6.271l-1.315,3.972
		c-1.621-2.972-5.387-4.117-9.082-4.117c-5.049,0-8.507,2.146-9.903,5.146h-1.267c0.472-2,1.855-3.744,3.92-5.203
		c0.066-0.048-6.499,0.04-6.499,0.04c-0.789,0-1.515,0.174-2.305,0.734c-0.715,0.509-1.444,1.361-1.736,2.105l-9.34,28.324h7.232
		c1.086,0,1.787-0.266,2.638-0.867c0.741-0.527,1.091-1.013,1.38-1.818l1.587-4.642l1.355-4.409l4.738-14.264h3.646
		c2.761,0,5.36-0.503,3.829,4.621c-2.133,7.137-6.676,9.111-9.582,9.588l-1.277,3.996c5.077-0.074,16.262-1.162,19.664-8.745
		c1.865-4.154,2.173-7.46,1.499-9.46h5.426c0,0-3.09,9.445-3.911,11.875c-1.361,4.021,1.171,6.125,4.737,6.125h8.188
		c0,0,1.201-3.686,1.224-3.59c-3.411,0-4.41-0.695-3.411-3.688c0.654-1.964,3.528-10.722,3.528-10.722h5.795
		c0,0-3.184,9.529-3.97,11.972c-1.248,3.881,1.402,6.071,4.792,6.126c1.888,0.031,8.188,0.012,8.191,0.012
		c0,0,1.197-3.739,1.222-3.645c-3.414,0-4.412-0.723-3.414-3.715c0.659-1.964,3.528-10.75,3.528-10.75h5.396l1.662-5H114.608z"
      />
      <path
        d="M32.862,18.555c-2.738-3.187-4.699-5.315-6.439-7.856c-1.61-2.353-2.61-4.348-2.61-6.407
		c0-1.999,0.806-4.123,0.806-4.123L24.57,0c-2.368,5.708-3.72,9.123-3.269,13.983c0.482,5.184,4.011,9.34,7.245,12.813
		c2.609,2.803,4.186,4.573,4.911,7.792c0.503,2.23,0.796,6.956-2.555,11.499c-4.006,5.432-10.761,5.624-10.761,5.624v1.635
		c0,0,7.992-0.304,13.241-5.072c3.627-3.29,5.055-6.158,6.001-10.592c0.806-3.766-0.09-9.139-2.44-13.267
		C35.625,22.097,34.247,20.166,32.862,18.555z"
      />
      <path
        d="M8.64,46.087c-3.349-4.543-2.781-9.269-2.281-11.499c0.726-3.219,2.298-4.988,4.906-7.792
		c3.234-3.473,6.758-7.629,7.24-12.813c0.453-4.86-0.903-8.275-3.27-13.983l-0.048,0.168c0,0,0.803,2.125,0.803,4.123
		c0,2.059-0.998,4.054-2.606,6.407c-1.742,2.541-3.703,4.669-6.44,7.856c-1.382,1.611-2.834,3.542-4.153,5.86
		c-2.352,4.128-3.317,9.501-2.513,13.267c0.947,4.434,2.257,7.302,5.882,10.592c5.25,4.769,12.981,5.072,12.981,5.072v-1.635
		C19.142,51.711,12.647,51.519,8.64,46.087z"
      />
      <path
        d="M32.538,37.959c0-3.554-1.454-6.779-3.829-9.058c-2.312-2.221-5.162-5.71-6.287-7.553
		c-2.016-3.298-2.521-6.177-2.521-6.177s-0.536,2.885-2.56,6.177c-1.904,3.093-5.266,6.569-6.373,7.677
		c-2.286,2.286-3.702,5.442-3.702,8.934c0,6.978,5.657,12.633,12.635,12.633S32.538,44.937,32.538,37.959z M19.902,48.281
		c-5.7,0-10.323-4.622-10.323-10.322c0-5.701,4.623-10.323,10.323-10.323c5.702,0,10.323,4.622,10.323,10.323
		C30.225,43.659,25.604,48.281,19.902,48.281z"
      />
    </g>
  </svg>
);

const Ptt_ful = (props) => <Icon component={icon} {...props} />;

export default Ptt_ful;
